<template>
    <div class="wrapContainer">
        <div class="top">

            <div class="topContainer clearfix">
                <div class="left">
                    <span class="tag">{{time}}</span>
                </div>
                <div class="right">
                    <span class="outline tag" @click="doLogin">会员登录</span>
                    <span class="outline tag" @click="doDown">下载专区</span>
                    <span class="outline tag" @click="doContact">联系我们</span>
                    <span class="outline tag" @click="doFeedback">委员反馈</span>
                    <span class="outline" @click="doMistake">网站纠错</span>
                </div>
            </div>
        </div>
        <div class="middle">
            <div class="middleContainer clearfix">
                <div class="left logo" @click="goIndex">
                    <img src="./../../assets/logo.png"/>
                </div>
                <div class="right search">
                    <div class="searchBox clearfix">
                        <div class="searchInput left">
                            <img src="./../../assets/search.png"/>
                            <input type="text" v-model="key" placeholder="请输入关键字" @keydown="getInputValue" />
                        </div>
                        <div class="searchBtn right">
                            <button @click="goSearch">搜索</button>
                        </div>
                    </div>
                    <div class="weiChat">
                        <span @click="openWeibo('0')"><i class="weiBo"></i><label>陕西保健学会</label></span>
                        <span @click="openWeibo('1')"><i class="weiBo"></i><label>大众医学教育</label></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- https://media.lotusdata.com/136627251562258782.jpg
        https://media.lotusdata.com/136627375059280222.jpg -->
        <!-- <img src="https://media.lotusdata.com/136627251562258782.jpg" alt="" style="width:100%"> -->
        <div class="bottom">
            <div class="bottomContainer row">
                <div class="homepage" @click="goIndex">首页</div>
                <template v-for="item in menuList">
                    <div class="transItem" :key="'t' + item.id" >
                        <div class="homepage" :key="'h' + item.id">
                            {{item.title}}
                        </div>
                        <div class="downItem" :key="'f' + item.id">
                            <div style="display: block;white-space:nowrap;padding: 0px 20px;width: auto;" v-for="child in item.children"  :key="child.id" @click="openAllList(child.title, child.id, child.dtype, child.newslink, child.Showstyle)">
                                {{child.title}}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "headPart",
        props: {
            menuList: {
                type: Array,
                required: true
            },
        },
        data () {
            return{
                time: '',
                week: '',
                key: '',
                timefunc: ''
            }
        },
        methods: {
            goSearch () {
                if(this.key == ''){
                    return;
                }
                this.$router.push({
                    path: '/more/search',
                    query: { key: this.key }
                });
            },
            openAllList (title, id, dtype, link, Showstyle) {
                if(dtype == 1&&link) {
                  if (link.indexOf('https://www.sxbjxh.org.cn')!=-1) {
                    window.location.href= link
                    return
                  }else {
                    window.open(link)
                    return
                  }
                }
                // return
                if(id == '8707426274508819'){//基金捐赠
                    window.open("http://www.sxscsxh.cn/fv.html?id=744f8520-a780-4fc0-a15c-e8dff4f3b4a9")
                    return
                }
                 if(id == '126317164331286401'){ //内部刊物
                    window.open("https://share.lotusdata.com/teamcontent/index?orgId=44822039860616108")
                    return
                }
                // 专家介绍
                if (id == '23') {
                    this.$router.push({
                        path: '/more/doc',
                        query: { type: 'commit', Showstyle }
                    });
                    return
                }
                // 会议视频
                if (id == '366733301051119603') {
                    this.$router.push({
                        path: '/more/doc',
                        query: { type: 'video', video: '会议视频', Showstyle }
                    });
                    return
                }
                // 讲座视频
                if (id == '31') {
                    this.$router.push({
                        path:'/more/doc',
                        query: { type: 'video', video: '公益讲座', Showstyle  }
                    });
                    return
                }
                if (id == '33') {
                    location.href = 'https://share.lotusdata.com/teamcontent/index?orgId=44822039860616108'
                    return
                }
                this.$router.push({
                    path: '/news/alllist',
                    query: { id: id, title: title, Showstyle }
                });
            },
            goIndex () {
                this.$router.push({
                    path: '/home'
                });
            },
            doLogin () {
                window.open('https://www.sxbjxh.org.cn/login')
            },
            doDown () {
                var id = "2408952530874553921";
                var title = "下载专区";
                this.$router.push({
                    path: '/news/tab',
                    query: { id: id, title: title }
                });
            },
            doContact () {
                var id = "7887041547071738805";
                this.$router.push({
                    path: '/news/detail',
                    query: { id: id }
                });
            },
            doFeedback () {
                this.$router.push({
                    path: '/more/feedback'
                })
            },
            doMistake () {
                this.$router.push({
                    path: '/more/mistake'
                })
            },
            openWeibo (num) {
                if (num == "0") {
                    window.open('https://weibo.com/sxbjxh')
                } else {
                    window.open('https://weibo.com/u/5210798932')
                }
            },
            getInputValue (e) {
                if (e.keyCode === 13) {
                    this.goSearch();
                }
            }
        },
        mounted () {
            var that = this;
            getTime();
            function getTime () {
                var date = new Date();
                that.time = date.getFullYear()+"年"+(date.getMonth()+1)+"月"+date.getDate()+"日";
                var hours = date.getHours(),
                    minites = date.getMinutes(),
                    seconds = date.getSeconds();
                var week = '';
                if (date.getDay() == 1) {
                    week = '星期一';
                }
                if (date.getDay() == 2) {
                    week = '星期二';
                }
                if (date.getDay() == 3) {
                    week = '星期三';
                }
                if (date.getDay() == 4) {
                    week = '星期四';
                }
                if (date.getDay() == 5) {
                    week = '星期五';
                }
                if (date.getDay() == 6) {
                    week = '星期六';
                }
                if (date.getDay() == 0) {
                    week = '星期天';
                }
                that.time = that.time + ' ' + week + ' ' + (hours < 10 ? '0' + hours : hours) +": "+ (minites < 10 ? '0' + minites : minites) + ": " + (seconds < 10 ? '0' + seconds : seconds);
            }
            this.timefunc = setInterval(getTime, 1000);
        },
        beforeDestroy () {
            clearInterval(this.timefunc);
        }
    }
</script>

<style lang="less" scoped>
    @base: #3e8f83;
    @baseBase: #eaf0eb;
    @pcWidth: 1230px;
    @padWidth: 982px;
    .wrapContainer{
        width:100%;
        height: auto;
        background-color: #ffffff;
    }
    .top{
        width:100%;
        height: 40px;
        line-height: 40px;
        background-color: @baseBase ;
    }
    .topContainer{
        width: @pcWidth;
        height: 100%;
        font-size:14px;
        margin: 0 auto;
        span{
            display: inline-block;
        }
        span.tag{
            margin-right:20px;
        }
    }
    .outline{
        text-decoration:underline;
        cursor: pointer;
    }
    .middle{
        width:100%;
        height: 90px;
        padding: 20px 0;
        box-sizing: content-box;
        background-color: #ffffff;
    }
    .middleContainer{
        width: @pcWidth;
        height: 100%;
        margin: 0 auto;
        .logo{
            width: 395px;
            height: 90px;
            cursor: pointer;
        }
        img{
            width:100%;
            height: 100%;
        }
        .search{
            height: auto;
            .searchBox{
                height: 40px;
            }
            .searchInput{
                width: 280px;
                height: 100%;
                background-color: #f7f7f7;
                border: 1px solid #e7e7e7;
                border-radius: 20px;
                margin-right: 15px;
                box-sizing: border-box;
                input {
                    width: 200px;
                    height: 24px;
                    line-height: 24px;
                    margin: 7px 0;
                    font-size: 14px;
                    background-color: transparent;
                }
                img{
                    width: 20px;
                    height: 20px;
                    margin: 0 10px;
                    vertical-align: middle;
                }
            }
            .searchBtn{
                width: 90px;
                height: 100%;
                button{
                    width: 100%;
                    height: 100%;
                    line-height: 100%;
                    border-radius: 20px;
                    color: #ffffff;
                    font-size: 14px;
                    background-color: @base;
                    outline: none;
                    cursor: pointer;
                }
            }
            .weiChat{
                height:30px;
                font-size: 14px;
                text-align: right;
                margin-top: 10px;
                span{
                    display: inline-block;
                    height:30px;
                    margin-left: 20px;
                    cursor: pointer;
                }
                label{
                    text-decoration: underline;
                    margin-bottom: 0;
                    cursor: pointer;
                }
                i:before{
                    width: 30px;
                    height: 25px;
                    display: inline-block;
                    content: '';
                    background-size:auto 25px;
                    vertical-align: middle;
                }
            }
            .weiBo:before{
                background: url("./../../assets/weibo.png") no-repeat;
            }
            .weiXin:before{
                background: url("./../../assets/weixin.png") no-repeat;
            }
        }
    }
    .bottom{
        width: 100%;
        height: 45px;
        line-height: 45px;
        background-color: @base;
    }
    .bottomContainer{
        width: @pcWidth;
        height: 100%;
        color: #ffffff;
        margin: 0 auto;
        .dropDownItem{
            color: #ffffff;
            height: 43px;
            background-color: @base;
            outline: none;
            font-size:15px;
            cursor: pointer;
        }
        .transItem{
            position: relative;
        }
        .downItem{
            display: none;
        }
        .downItem{
            position: absolute;
            z-index: 9;
            background-color: @base;
            color:#fff;
            min-width:123px;
            border-bottom-right-radius: 6px;
            border-bottom-left-radius: 6px;
            text-align: center;
            font-size: 12px;
            transition:all 0.3s linear;
            cursor: pointer;
            overflow: hidden;
        }
        .transItem:hover {
            .downItem{
                display: block;
            }
            .homepage{
                background-color: #40a498;
            }
        }
        .downItem div:hover{
            background-color: #40a498;
        }
        .homepage{
            width:123px;
            font-size:15px;
            cursor: pointer;
            text-align: center;
            transition:all 0.3s linear;
        }
    }
    @media screen and (max-width:1260px){
        .topContainer{
            width: @padWidth;
        }
        .middleContainer{
            width: @padWidth;
        }
        .bottomContainer{
            width: @padWidth;
            .dropDownItem{
                font-size:12px;
            }
            .homepage{
                width:109px;
                font-size:12px;
            }
            .downItem{
                width:109px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pc/headPart.vue